import { Market, markets } from '@web-creditea/interfaces';
import { match } from 'ts-pattern';

export const getCanonicalUrl = (market: Market, basePath: string, asPath: string): URL =>
  match(market)
    .with(markets.mx, () => new URL(`https://www.creditea.mx${asPath}`))
    .with(markets.cz, () => new URL(`https://www.creditea.cz${asPath}`))
    .with(markets.ecommerce, () => new URL(`https://ecommerce.creditea.com${basePath}${asPath}`))
    .otherwise(() => new URL(`https://www.creditea.com${basePath}${asPath}`));
